module.exports = __webpack_public_path__ + "img/modal-branch.c5ee74af.svg";